import { X } from "lucide-react"
import { Dialog, DialogContent } from "@/components/ui/dialog"
import { useTranslation } from "@/language"

interface EditProfileTipsModalProps {
  isOpen: boolean
  onClose: () => void
}

export function EditProfileTipsModal({ isOpen, onClose }: EditProfileTipsModalProps) {
  const { t } = useTranslation("profile")

  return (
    <Dialog open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent
        showCloseButton={false}
        overlayClass="bg-[#020202E5]"
        className="fixed top-10 left-0 right-0 translate-x-0 translate-y-0 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 border border-dashed rounded-xl bg-card border-card text-[#F2F0EB] md:pt-12.5 md:pb-10 md:px-12.5 gap-7.5 max-w-full rounded-bl-2xl rounded-br-2xl"
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-4 top-4 text-[#F2F0EB] bg-[#F2F0EB0D] border border-[#F2F0EB26] p-2.5 rounded-full transition-opacity hover:opacity-100 focus:outline-none"
        >
          <X className="h-4 w-4" />
        </button>

        <div>
          <h3 className="text-xl font-semibold mb-3 text-primary">{t("editProfile.tips")}</h3>
          <ul className="font-montserrat text-[14px] font-normal leading-[25px] text-primary list-none">
            <li className="flex items-start gap-2">
              <span>.</span>
              <span>{t("editProfile.tipsList.realName")}</span>
            </li>
            <li className="flex items-start gap-2">
              <span>.</span>
              <span>{t("editProfile.tipsList.shortBio")}</span>
            </li>
            <li className="flex items-start gap-2">
              <span>.</span>
              <span>{t("editProfile.tipsList.clearPhoto")}</span>
            </li>
            <li className="flex items-start gap-2">
              <span>.</span>
              <span>{t("editProfile.tipsList.comfortable")}</span>
            </li>
          </ul>
        </div>
      </DialogContent>
    </Dialog>
  )
}
